import { Cascader, Input, InputNumber, Select } from 'antd';
import { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import className from 'classnames';
import { EventEmitter } from 'events';
import { Delete } from 'patternx-svg';
interface Props {
  info: any;
  categoryOptions: any[];
  eventBus: EventEmitter;
  onDelete: (uid: string) => void;
  onNameChange: (name: string) => void;
  onCategoryChange: (category: any) => void;
  appOptions: any[];
  onWidthChange: (width: number) => void;
  onLongChange: (long: number) => void;
  onAppChange: (ids: string[]) => void;
  businessCategorys: any[];
  onBusinessCategoryChange: (category: any) => void;
}
const InfoCard: React.FC<Props> = (props: Props) => {
  const {
    categoryOptions,
    info,
    eventBus,
    onNameChange,
    onCategoryChange,
    onDelete,
    appOptions,
    onWidthChange,
    onLongChange,
    onAppChange,
    businessCategorys,
    onBusinessCategoryChange,
  } = props;
  const cardRef = useRef<HTMLDivElement>(null);
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const [isCategoryInvalid, setIsCategoryInvalid] = useState(false);
  const [isLongInvalid, setIsLongInvalid] = useState(false);
  const [isWidthInvalid, setIsWidthInvalid] = useState(false);
  const [isAppInvalid, setIsAppInvalid] = useState(false);
  const [isBusinessCategoryInvalid, setIsBusinessCategoryInvalid] = useState(false);

  useEffect(() => {
    // 监听invalid 检测消息
    eventBus.addListener('invalid', (uid, target) => {
      if (info.uid !== uid) {
        return;
      }
      setIsNameInvalid(false);
      setIsCategoryInvalid(false);
      setIsLongInvalid(false);
      setIsWidthInvalid(false);
      setIsAppInvalid(false);
      setIsBusinessCategoryInvalid(false);
      switch (target) {
        case 'name':
          setIsNameInvalid(true);
          break;
        case 'categoryId':
          setIsCategoryInvalid(true);
          break;
        case 'long':
          setIsLongInvalid(true);
          break;
        case 'width':
          setIsWidthInvalid(true);
          break;
        case 'app':
          setIsAppInvalid(true);
          break;
        case 'businesscategoryId':
          setIsBusinessCategoryInvalid(true);
          break;
      }
      cardRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    });
  }, []);

  const onLocalNameChange = (e: any) => {
    const value = e.target?.value.trim();
    onNameChange(value);
  };
  const onLocalCategoryChange = (values: any) => {
    // console.log(values, '====values');
    if (!values || values.length === 0) {
      onCategoryChange('');
    } else if (values.length === 1) {
      onCategoryChange(values[0]);
    } else if (values.length === 2) {
      onCategoryChange(values[1]);
    }
  };

  const onLocalBusinessCategoryChange = (values: any) => {
    // console.log(values, '====values');
    if (!values || values.length === 0) {
      onBusinessCategoryChange('');
    } else {
      onBusinessCategoryChange(values[values.length - 1]);
    }
  };

  const onLocalAppChange = (e: any) => {
    // console.log(e, '=====onAppChange');
    onAppChange(e);
  };

  const onLocalLongChange = (e: any) => {
    onLongChange(e || 0);
  };

  const onLocalWidthChange = (e: any) => {
    onWidthChange(e || 0);
  };

  //文件名截取后缀之前的部分
  const getFileName = (name: string) => {
    const lowerName = name?.toLowerCase();
    const isIntercept =
      lowerName.endsWith('.png') || lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg');
    if (isIntercept) {
      return name?.slice(0, name?.lastIndexOf('.'));
    }
    return name;
  };

  const [imgStyle, setImgStyle] = useState<any>({ width: '100%', height: 'auto' });
  useEffect(() => {
    if (info.fileUrl) {
      const imgEle = new Image();
      imgEle.src = info.fileUrl;
      imgEle.onload = function () {
        if (imgEle.width >= imgEle.height) {
          setImgStyle({
            width: '100%',
            height: 'auto',
          });
        } else {
          setImgStyle({
            height: '100%',
            width: 'auto',
          });
        }
      };
    }
  }, [info.fileUrl]);

  return (
    <div className={styles.infoCard} ref={cardRef}>
      <div className={styles.thumb}>
        <div className={styles.icon}>
          <img src={info.fileUrl} style={imgStyle} />
        </div>
        <a className={styles.delete} onClick={() => onDelete(info.uid)}>
          <Delete size={20} />
          删除
        </a>
      </div>
      <div className={styles.info}>
        <div className={styles.itemRow}>
          <div className={className(styles.pickTitle, styles.required, styles.required2)}>名称</div>
          <div className={styles.pickContent}>
            <Input
              className={className({
                [styles.invalid]: isNameInvalid,
              })}
              maxLength={50}
              defaultValue={getFileName(info.name)}
              onChange={onLocalNameChange}
              onFocus={() => {
                setIsNameInvalid(false);
              }}
            />
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={className(styles.pickTitle, styles.required, styles.required2)}>分类</div>
          <div className={className(styles.pickContent)}>
            <Cascader
              className={className({
                [styles.invalid]: isBusinessCategoryInvalid,
              })}
              expandTrigger="hover"
              options={businessCategorys}
              style={{ flex: 1 }}
              onChange={onLocalBusinessCategoryChange}
              onFocus={() => setIsBusinessCategoryInvalid(false)}
              placeholder="选择分类"
              placement="bottomLeft"
              // getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={className(styles.pickTitle, styles.required)}>物理属性</div>
          <div className={className(styles.pickContent)}>
            <Cascader
              className={className({
                [styles.invalid]: isCategoryInvalid,
              })}
              expandTrigger="hover"
              options={categoryOptions}
              style={{ flex: 1 }}
              onChange={onLocalCategoryChange}
              onFocus={() => setIsCategoryInvalid(false)}
              placeholder="选择物理属性"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            />
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={className(styles.pickTitle, styles.required, styles.required1)}>
            <span style={{ visibility: 'hidden' }}>长</span>长
          </div>
          <div className={className(styles.pickContent)}>
            <InputNumber
              className={className({
                [styles.invalid]: isLongInvalid,
              })}
              defaultValue={info.length}
              // min={10}
              // max={10000}
              onChange={onLocalLongChange}
              onFocus={() => {
                setIsLongInvalid(false);
              }}
              addonAfter={<span className={styles.inputAfter}>mm</span>}
            />
          </div>
          <div className={className(styles.pickTitle, styles.required, styles.required1)}>
            <span style={{ visibility: 'hidden' }}>宽</span>宽
          </div>
          <div className={className(styles.pickContent)}>
            <InputNumber
              className={className({
                [styles.invalid]: isWidthInvalid,
              })}
              defaultValue={info.width}
              // min={10}
              // max={10000}
              onChange={onLocalWidthChange}
              onFocus={() => {
                setIsWidthInvalid(false);
              }}
              addonAfter={<span className={styles.inputAfter}>mm</span>}
            />
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={className(styles.pickTitle, styles.required, styles.required2)}>应用</div>
          <div className={className(styles.pickContent, styles.pickPropery)}>
            <Select
              className={className({
                [styles.invalid]: isAppInvalid,
              })}
              mode="multiple"
              placeholder="请选择应用"
              defaultValue={info?.appList || []}
              onChange={onLocalAppChange}
              style={{ width: '100%' }}
              options={appOptions}
              showArrow
              onFocus={() => {
                setIsNameInvalid(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
